import Util from "./utils";

const DOMAIN = process.env.REACT_APP_DOMAIN;

export function toSignIn(props, rc) {
    props.history.push("/signin" + (Util.isNull(rc) ? '' : ('?r_c=' + rc)));
}

export function toIndex(props) {
    props.history.push("/index");
}

export function toSubsAuth(props, data) {
    var path = "/subs_auth?i=" + encodeURIComponent(JSON.stringify(data));
    props.history.push(path);
}

export let PATH_NAME = {
    subsFission: 'subsFission',
    qunFission: 'qunFission',
    taskposter: 'taskposter',
    message: 'message',
    channel: "channel",
    share: "share",
    home: 'home',
    subsAuth: 'subsAuth',
    tpManage: 'tpManage',
    tpCreate: 'tpCreate',
    tpBlacklist: 'tpBlacklist',
    tmRecord: 'tmRecord',
    tmCreate: 'tmCreate',
    authentication: "Authentication",
    mine: 'mine',
    orderAdd: 'orderAdd',
    orderList: 'orderList',
    myShop: 'myShop',
    goodsList: 'goodsList',
    goodsCreate: 'goodsCreate',
    goodsOrderList: 'goodsOrderList',
    goodsEdit: 'goodsEdit',
    goodsOrderDetail: 'goodsOrderDetail',
};

export let PATH = {
    home: '/index/dashboard',
    subsFission: '/index/ext/subs',
    qunFission: '/index/group/task/list',
    subsAuth: '/index/ext/subs',
    tpManage: '/index/ext/taskpost/record',
    tpCreate: '/index/ext/taskpost/create',
    tpBlacklist: '/index/ext/taskpost/blacklist',
    tpChannel: '/index/ext/taskpost/channel',
    tpChannelCreate: '/index/ext/taskpost/channel_create',
    tpChannelEdit: '/index/ext/taskpost/channel_edit',
    tpChannelDetail: '/index/ext/taskpost/channel_stats/',
    tpStas: '/index/ext/taskpost/stas/0',
    tpEdit: '/index/ext/taskpost/edit',
    tpCopy: '/index/ext/taskpost/copy',
    tpDetail: '/index/ext/taskpost/detail/',
    tmCreate: '/index/ext/msg_template/task/create',
    tmRecord: '/index/ext/msg_template/task/record',
    channelQRList: '/index/ext/channelqrcode/manage/list',
    channelQREdit: '/index/ext/channelqrcode/edit/',
    channelQRStats: '/index/ext/channelqrcode/stats/0',
    channelQRCreate: '/index/ext/channelqrcode/create',
    stManage: '/index/ext/st/record',
    stEdit: '/index/ext/st/edit/',
    stCreate: '/index/ext/st/create',
    stDetail: '/index/ext/st/detail/0',
    fansManage: '/index/ext/fans/manage',
    // formCreate: '/index/ext/mform/create',
    // formEdit: '/index/ext/mform/edit/',
    // formData: '/index/ext/mform/data/',
    formManage: '/index/ext/mform/manage',
    taskpostFormManage: '/index/ext/taskpost/mform/manage',
    redeemCodeManage: '/index/ext/redeemcode/manage',
    taskpostRedeemCodeManage: '/index/ext/taskpost/redeemcode/manage',
    redeemCodeCreate: '/index/ext/redeemcode/create',
    redeemCodeDate: '/index/ext/redeemcode/data/',
    Authentication: '/index/ext/authentication',//认证
    festivalSignList: '/index/ext/festivalsign/list',//节日签
    festivalSignCreate: '/index/ext/festivalsign/create',
    festivalSignEdit: '/index/ext/festivalsign/edit/',
    festivalSignCopy: '/index/ext/festivalsign/copy/',

    // 订单管理
    mine: '/index/mine',
    orderAdd: '/index/mine/order/add',
    orderList: '/index/mine/order/list',
    orderConfirm: '/index/mine/order/confirm',
    orderPay: '/index/mine/order/pay',
    orderDetail: '/index/mine/order/detail',

    //商铺
    myShop: '/index/myshop',
    goodsList: '/index/myshop/goods/list',
    goodsCreate: '/index/myshop/goods/create',
    goodsOrderList: '/index/myshop/order/list',
    goodsOrderChecker: '/index/market/ochecker/list',
    goodsOrderCheckerCreate: '/index/market/ochecker/create',
    goodsOrderCheckerData: '/index/market/ochecker/orderlist',
    goodsOrderDeliver: '/index/myshop/order/deliver',
    goodsEdit: '/index/myshop/goods/edit/',
    goodsOrderDetail: '/index/myshop/order/detail/',

    goodsListTaskpost: '/index/myshop/taskpost/goods/list',
    goodsCreateTaskpost: '/index/myshop/taskpost/goods/create',
    goodsOrderListTaskpost: '/index/myshop/taskpost/order/list',
    goodsOrderDeliverTaskpost: '/index/myshop/taskpost/order/deliver',
    goodsOrderCheckerTaskpost: '/index/myshop/taskpost/order/checker/list',
    goodsEditTaskpost: '/index/myshop/taskpost/goods/edit/',
    goodsOrderDetailTaskpost: '/index/myshop/taskpost/order/detail/',
};
//保存一级菜单包含的页面
let PATH_MAPPER = {
    subsFission: [
        PATH.subsManage,
        PATH.tpManage,
        PATH.tpEdit,
        PATH.tpCreate,
        PATH.tpBlacklist,
        PATH.tpChannel,
        PATH.tpStas,
        PATH.tpCopy,
        PATH.tpDetail,
        PATH.tmCreate,
        PATH.tmRecord,
        PATH.channelQRList,
        PATH.channelQREdit,
        PATH.channelQRStats,
        PATH.channelQRCreate,
        PATH.stManage,
        PATH.stEdit,
        PATH.stCreate,
        PATH.stDetail,
        PATH.fansManage,
        PATH.formCreate,
        PATH.formEdit,
        PATH.formData,
        PATH.formManage,
        PATH.redeemCodeManage,
        PATH.redeemCodeCreate,
        PATH.redeemCodeDate,
        PATH.Authentication
    ],
    qunFission: [],
    mine: [
        PATH.orderList,
        PATH.orderAdd,
        PATH.orderConfirm,
        PATH.orderPay,
        PATH.orderDetail
    ]
};

class Path {

    static isSubsFissionPath(url) {
        if (Util.isNull(url)) {
            url = window.location.href;
        }
        let subsFission = PATH_MAPPER.subsFission;
        for (let i = 0; i < subsFission.length; i++) {
            if (url.endsWith(subsFission[i])) {
                return true;
            }
        }
        return false;
    }

    static isSubsAuth() {
        let url = Path.getUrl();
        if (url.indexOf(Path.getSubsManagePath()) > 0) {
            return true;
        }
        return false;
    }

    static getAgreement() {
        return '/agreement';
    }

    static getHttpHomePath() {
        return DOMAIN + '/home.html';
    }

    static getChannelQRCodeListPath() {
        return '/index/ext/channelqrcode/manage/list';
    }

    static getChannelQRCodeEditPath() {
        return '/index/ext/channelqrcode/edit/';
    }

    static getChannelQRCodeStatsPath() {
        return '/index/ext/channelqrcode/stats/';
    }


    static getCreateChannelQRCodePath() {
        return '/index/ext/channelqrcode/create';
    }

    static getShareTreasureRecordPath() {
        return "/index/ext/st/record"
    }

    static getShareTreasureCreatePath() {
        return "/index/ext/st/create"
    }

    static getShareTreasureEditPath() {
        return "/index/ext/st/edit/"
    }

    static getShareTreasureDetailPath() {
        return "/index/ext/st/detail/"
    }

    static getCreateTaskposterPath() {
        return "/index/ext/taskpost/create"
    }

    static getBlacklistTaskposterPath() {
        return "/index/ext/taskpost/blacklist"
    }

    static getChannelTaskposterPath() {
        return "/index/ext/taskpost/channel"
    }

    static getCopyTaskposterPath() {
        return "/index/ext/taskpost/copy"
    }

    static getEditTaskposterPath() {
        return "/index/ext/taskpost/edit"
    }

    static getTaskposterDetailPath() {
        return "/index/ext/taskpost/detail/"
    }

    static getTaskposterStasPath() {
        return "/index/ext/taskpost/stas/"
    }

    static getTaskposterFansPath() {
        return "/index/ext/taskpost/fans/"
    }

    static getTaskposterChannelPath() {
        return "/index/ext/taskpost/channel/"
    }

    static getTaskposterChannelCreatePath() {
        return "/index/ext/taskpost/channel_create"
    }

    static getTaskposterChannelEditPath() {
        return '/index/ext/taskpost/channel_edit'
    }

    static getCreatePushMsgTaskPath() {
        return "/index/ext/msg_template/task/create/"
    }

    static getTemplateMsgManagePath() {
        return "/index/ext/msg_template/manage"
    }

    static getCreateMsgPath() {
        return "/index/ext/msg_template/create"
    }

    static getEditMsgPath() {
        return "/index/ext/msg_template/edit"
    }

    static getMsgTemplatePath() {
        return "/index/ext/msg_template/manage/my_template"
    }

    static getMsgTaskRecordPath() {
        return "/index/ext/msg_template/task/record"
    }

    static getTaskPosterRecordPath() {
        return "/index/ext/taskpost/record"
    }

    static getSigninHttpPath() {
        return DOMAIN + "/signin";
        // return "http://localhost/signin";
    }

    static getHomeHttpPath() {
        return DOMAIN + "/signin";
        // return "http://localhost/signin";
    }

    static getSigninPath(target) {
        if (target) {
            return "/login?target=" + target;
        }
        return "/login";
    }

    static getSignUpPath() {
        return "/register";
    }

    static getExtPath() {
        return '/index/ext';
    }

    static getHomePath() {
        return PATH.home;
    }

    static getFansPath() {
        return "/index/ext/fans/manage"
    }

    static getVipPurPath() {
        return "/vip"
    }

    static getCreateFormPath() {
        return "/index/ext/mform/create"
    }

    static getEditFormPath() {
        return "/index/ext/mform/edit/"
    }

    static getFormDataPath() {
        return "/index/ext/mform/data/"
    }

    static getManageFormPath() {
        return "/index/ext/mform/manage"
    }

    static getFormLookPath() {
        return "/index/ext/mform/look/"
    }

    static getTaskpostCreateFormPath() {
        return "/index/ext/taskpost/mform/create"
    }

    static getTaskpostEditFormPath() {
        return "/index/ext/taskpost/mform/edit/"
    }

    static getTaskpostFormDataPath() {
        return "/index/ext/taskpost/mform/data/"
    }

    static getTaskpostManageFormPath() {
        return "/index/ext/taskpost/mform/manage"
    }

    static getTaskpostFormLookPath() {
        return "/index/ext/taskpost/mform/look/"
    }


    static getCorpCreateFormPath() {
        return "/index/corp/mform/create"
    }

    static getCorpEditFormPath() {
        return "/index/corp/mform/edit/"
    }

    static getCorpFormDataPath() {
        return "/index/corp/mform/data/"
    }

    static getCorpManageFormPath() {
        return "/index/corp/mform/manage"
    }

    static getCorpFormLookPath() {
        return "/index/corp/mform/look/"
    }


    static getManageRedeemcodePath() {
        return "/index/ext/redeemcode/manage"
    }

    static getCreateRedeemcodePath() {
        return "/index/market/config/redeemcode/create"
    }

    static getRedeemcodeDataPath() {
        return "/index/redeemcode/data/"
    }

    static getRedeemcodeCreatePath() {
        return "/index/ext/redeemcode/create"
    }


    static getTaskpostManageRedeemcodePath() {
        return "/index/ext/taskpost/redeemcode/manage"
    }

    static getTaskpostCreateRedeemcodePath() {
        return "/index/ext/taskpost/redeemcode/create"
    }

    static getTaskpostRedeemcodeDataPath() {
        return "/index/ext/taskpost/redeemcode/data/"
    }

    static getTaskpostRedeemcodeCreatePath() {
        return "/index/ext/taskpost/redeemcode/create"
    }


    static getCorpManageRedeemcodePath() {
        return "/index/corp/redeemcode/manage"
    }

    static getCorpCreateRedeemcodePath() {
        return "/index/corp/redeemcode/create"
    }

    static getCorpRedeemcodeDataPath() {
        return "/index/corp/redeemcode/data/"
    }

    static getCorpRedeemcodeCreatePath() {
        return "/index/corp/redeemcode/create"
    }


    static getSubsManagePath() {
        return "/index/ext/subs"
    }

    static getAuthenticationPath() {
        return "/index/ext/authentication"
    }

    static getMine() {
        return "/index/mine"
    }

    static getOrderList() {
        return "/index/mine/order/list"
    }

    static getOrderAdd() {
        // return "/index/mine/order/add"
        return '/index/mine/purchase/recharge'
    }

    static getOrderRenew() {
        return "/index/mine/order/renew"
    }

    static getOrderConfirm() {
        return "/index/mine/order/confirm"
    }

    static getOrderPay() {
        return "/index/mine/order/pay"
    }

    static getOrderDetail() {
        return "/index/mine/order/detail"
    }

    static getGoodsCreate() {
        return "/index/myshop/goods/create"
    }

    static getGoodsList() {
        return "/index/myshop/goods/list"
    }

    static getGoodsEdit() {
        return "/index/myshop/goods/edit/"
    }

    static getGoodsOrderList() {
        return "/index/myshop/order/list"
    }


    static getGoodsOrderDetail() {
        return "/index/myshop/order/detail/"
    }


    static getNoticeList() {
        return "/index/notice"
    }

    static getPurchase() {
        return "/index/purchase"
    }

    static getGroupTaskList() {
        return '/index/group/task/list'
    }

    static getTaskGroupList() {
        return '/index/group/task/group/'
    }

    static getGroupTaskCreate() {
        return '/index/group/task/create'
    }

    static getGroupTaskEdit() {
        return '/index/group/task/edit/'
    }

    static getGroupTaskCopy() {
        return '/index/group/task/copy/'
    }

    static getGroupPurchase() {
        return '/index/group/purchase/recharge'
    }

    static getGroupPurchasePay() {
        return '/index/group/purchase/pay'
    }

    static getGroupPurchasePayResult() {
        return '/index/group/purchase/result'
    }

    static getGroupPurchaseRecord() {
        return '/index/group/purchase/record'
    }

    static getGroupPurchaseRecordDe() {
        return '/index/group/purchase/detail'
    }

    static getGroupPurchaseStream() {
        return '/index/group/purchase/stream'
    }

    static getGroupPurchaseAccount() {
        return '/index/group/purchase/account'
    }


    static getGroupBlackList() {
        return '/index/group/black/list'
    }

    static getGroupMembers() {
        return '/index/group/task/members/list'
    }

    static getGroupDataCount() {
        return '/index/group/task/count'
    }

    static getGroupRobotList() {
        return '/index/group/task/robot/list'
    }

    static getGroupSendList() {
        return '/index/group/task/send/list'
    }

    static getGroupCreateSend() {
        return '/index/group/task/send/create'
    }

    static getDis() {
        return '/index/distribution'
    }

    static getDisRetailList() {
        return '/index/distribution/retail/list'
    }

    /*新建分销路径*/
    // static getDisTribution() {
    //     return 'index/distri'
    // }

    static getDisTributionList() {
        return '/index/distri/retail/list/'
    }

    static getDisTributionChannelList() {
        return '/index/distri/channel/list'
    }

    static getDisTributionMsg() {
        return '/index/distri/msg/list'
    }


    static getPrizeUnlockList() {
        return '/index/prizeunlock/list'
    }

    static getPrizeDataAnalysis() {
        return '/index/prizeunlock/report'
    }

    static getPrizeFans() {
        // return '/index/prizeunlock/fans'
        return
    }

    static getPrizeUnlockOrder() {
        return '/index/prizeunlock/order'
    }

    //
    // static getPrizeUnlockOrderDetail() {
    //     return "/index/prizeunlock/detail/"
    // }

    static getDisTriOrderDetail() {
        return "/index/distri/order/detail/"
    }

    static getDisRetailCreate() {
        return '/index/distribution/retail/create'
    }

    static getDisRetailEdit() {
        return '/index/distribution/retail/edit'
    }

    static getDisRetailCopy() {
        return '/index/distribution/retail/copy'
    }

    static getDisRetailData() {
        return '/index/distribution/retail/data'
    }

    static getDisRetailRank() {
        return '/index/distribution/retail/rank'
    }

    static getDisRetailReport() {
        return '/index/distribution/retail/report'
    }

    static getDisRetailCode() {
        return '/index/distribution/retail/code'
    }

    static getDisCashList() {
        return '/index/distribution/cash/record'
    }

    static getDisCashOut() {
        return '/index/distribution/cash/out'
    }

    static getDisPushase() {
        return '/index/mine/purchase/recharge'
    }

    static getWriteOffList() {
        return '/index/distribution/writeoff/list'
    }

    static getWriteOffCreate() {
        return '/index/distribution/writeoff/create'
    }

    static getWriteOffData() {
        return '/index/distribution/writeoff/data'
    }

    static getDisChannelList() {
        return '/index/distribution/channel/list'
    }

    static getDisMsg() {
        return '/index/distribution/msg/list'
    }

    static getDisMsgAdd() {
        return '/index/distribution/msg/create'
    }

    static getDisMsgEdit() {
        return '/index/distribution/msg/edit'
    }

    static getDisChannelCreate() {
        return '/index/distribution/channel/create'
    }

    static getDisChannelEdit() {
        return '/index/distribution/channel/edit'
    }

    static getDisRetailShop() {
        return '/index/distribution/retail/shop'
    }

    static getDisRetailShopEdit() {
        return '/index/distribution/retail/shop/edit'
    }

    static getPushList() {
        return '/index/ext/msg/push/list'
    }

    static getPushCreate() {
        return '/index/ext/msg/push/create'
    }

    static getPushEdit() {
        return '/index/ext/msg/push/edit'
    }

    static getPushCopy() {
        return '/index/ext/msg/push/copy'
    }

    static getGroupBuy() {
        return '/index/groupbuy'
    }

    static getGroupBuyList() {
        return '/index/groupbuy/list'
    }

    static getGroupBuyMsg() {
        return '/index/groupbuy/msg'
    }

    static getGroupBuyMsgAdd() {
        return '/index/groupbuy/msg/create'
    }

    static getGroupBuyMsgEdit() {
        return '/index/groupbuy/msg/edit'
    }

    static getGroupBuyCreat() {
        return '/index/groupbuy/create'
    }

    static getGroupBuyEdit() {
        return '/index/groupbuy/edit'
    }

    static getGroupBuyCopy() {
        return '/index/groupbuy/copy'
    }

    static getGroupBuyCash() {
        return '/index/groupbuy/cash/list'
    }

    static getGroupBuyCashOut() {
        return '/index/groupbuy/cash/out'
    }

    static getGroupBuyOrder() {
        return '/index/groupbuy/order/list'
    }

    static getGroupBuyOrderDetail() {
        return '/index/groupbuy/order/detail'
    }

    static getGroupBuyRedeemCode() {
        return '/index/groupbuy/code'
    }

    static getLiveCodeGroupList() {
        return '/index/livecode/group/list'
    }

    static getLiveCodeGroupCreate() {
        return '/index/livecode/group/create'
    }

    static getLiveCodeGroupEdit() {
        return '/index/livecode/group/edit'
    }

    static getLiveCodeGroupCopy() {
        return '/index/livecode/group/copy'
    }

    static getLiveCodeGroupQrcode() {
        return '/index/livecode/group/qrcode'
    }

    static getLiveCodeCustomerList() {
        return '/index/livecode/customer/list'
    }

    static getLiveCodePurchase() {
        return '/index/livecode/purchase'
    }

    static getLiveCodePurchaseConfirm() {
        return '/index/livecode/purchase/confirm'
    }

    static getLiveCodePay() {
        return '/index/livecode/purchase/pay'
    }

    static getLiveCodePayConfirm() {
        return '/index/livecode/purchase/confirm'
    }

    static getLiveCodePayResult() {
        return '/index/livecode/purchase/result'
    }

    static getLiveCodeCustomerCreate() {
        return '/index/livecode/customer/create'
    }

    static getLiveCodeCustomerEdit() {
        return '/index/livecode/customer/edit'
    }

    static getLiveCodeCustomerCopy() {
        return '/index/livecode/customer/copy'
    }

    static getLiveCodeCustomerQrcode() {
        return '/index/livecode/customer/qrcode'
    }

    static getLiveCustomCodeDataStat() {
        return '/index/livecode/customer/stat'
    }

    static getLiveGroupCodeDataStat() {
        return '/index/livecode/group/stat'
    }

    static getWXCreate() {
        return '/index/ext/wxmenu/create'
    }

    static getWXIndividuationList() {
        return '/index/ext/wxmenu/individuation/list'
    }

    static getWXIndividuationCreate() {
        return '/index/ext/wxmenu/individuation/create'
    }


    static getWXAutoReplay() {
        return '/index/ext/wxmenu/auto'
    }


    static getTpTags() {
        return '/index/ext/taskpost/tag/list'
    }

    static getTpTagsCreate() {
        return '/index/ext/taskpost/tag/create'
    }

    static getTpTagsEdit() {
        return '/index/ext/taskpost/tag/edit'
    }

    static getTpSop() {
        return '/index/ext/taskpost/sop/list'
    }

    static getTpSopCreate() {
        return '/index/ext/taskpost/sop/create'
    }

    static getTpSopEdit() {
        return '/index/ext/taskpost/sop/edit'
    }

    static getMinePurchase() {
        return '/index/mine/purchase/recharge'
    }

    static getMineProductInfo() {
        return '/index/mine/purchase/productinfo'
    }

    static getMinePay() {
        return '/index/mine/purchase/pay'
    }

    static getMineConfirm() {
        return '/index/mine/purchase/confirm'
    }

    static getMineResult() {
        return '/index/mine/purchase/result'
    }

    static getMineOrderList() {
        return '/index/mine/purchase/record'
    }

    static getMineOrderDetail() {
        return '/index/mine/purchase/detail'
    }


    // 企业微信
    static getCorpTaskList() {
        return '/index/corp/task/list'
    }

    static getCorpTaskAuth() {
        return '/index/corp/auth/list'
    }

    static getCorpTaskEWM() {
        return '/index/corp/auth/ewm'
    }

    static getCorpMemberList() {
        return '/index/corp/member/list'
    }

    static getCorpTaskFans() {
        return '/index/corp/task/fans/'
    }

    static getCorpTaskCreate() {
        return '/index/corp/task/create'
    }

    static getCorpTaskCopy() {
        return '/index/corp/task/copy/'
    }

    static getCorpTaskEdit() {
        return '/index/corp/task/edit/'
    }

    static getCorpTaskPlusCreate() {
        return '/index/corp/taskplus/create'
    }

    static getCorpTaskPlusCopy() {
        return '/index/corp/taskplus/copy/'
    }

    static getCorpTaskPlusEdit() {
        return '/index/corp/taskplus/edit/'
    }

    static getCorpData() {
        return '/index/corp/data/'
    }


    static getCorpFans() {
        return '/index/corp/task/fans/'
    }

    /*物流查询*/
    static getLogisticsList() {
        return '/index/logistics/list'
    }

    static getLogisticsCreate() {
        return '/index/logistics/create'
    }

    static getLogisticsEdit() {
        return '/index/logistics/edit/'
    }

    static getLogisticsLook() {
        return '/index/logistics/look/'
    }

    /*客户裂变物流查询*/
    static getCorpLogisticsList() {
        return '/index/corp/logistics/list'
    }

    /*任务宝物流查询*/
    static getTaskpostLogisticsList() {
        return '/index/ext/logistics/list'
    }

    static getAssetsStatements() {
        return "/index/market/assets/statements"
    }

    static getAssetsWithdraws() {
        return "/index/market/assets/withdraws"
    }

    static getAssetsCash() {
        return "/index/market/assets/cash"
    }

    static isTaskpostLogistics() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getTaskpostLogisticsList()) >= 0) {
            return true;
        }
        return false;
    }

    static isCorpLogistics() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getCorpLogisticsList()) >= 0) {
            return true;
        }
        return false;
    }

    static isLogistics() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getLogisticsList()) >= 0) {
            return true;
        } else if (url.indexOf(Path.getLogisticsCreate()) >= 0) {
            return true;
        } else if (url.indexOf(Path.getLogisticsEdit()) >= 0) {
            return true;
        } else if (url.indexOf(Path.getLogisticsLook()) >= 0) {
            return true;
        }
        return false;
    }

    static isCorpData() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getCorpData()) >= 0) {
            return true;
        }
        return false;
    }

    static isCorpFans() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getCorpFans()) >= 0) {
            return true;
        }
        return false;
    }

    static isCorpMemberList() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getCorpMemberList()) >= 0) {
            return true;
        }
        return false;
    }

    static isCorpMemberWx() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getCorpTaskAuth()) >= 0) {
            return true;
        }
        return false;
    }

    static isCorpTask() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getCorpTaskList()) >= 0) {
            return true;
        } else if (url.indexOf(Path.getCorpTaskEWM()) >= 0) {
            return true
        } else if (url.indexOf(Path.getCorpTaskFans()) >= 0) {
            return true
        } else if (url.indexOf(Path.getCorpTaskPlusCreate()) >= 0) {
            return true
        } else if (url.indexOf(Path.getCorpTaskPlusEdit()) >= 0) {
            return true
        } else if (url.indexOf(Path.getCorpTaskPlusCopy()) >= 0) {
            return true
        }
        return false;
    }

    static isMinePurchase() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getMinePurchase()) > 0) {
            return true;
        } else if (url.indexOf(Path.getMinePay()) > 0) {
            return true;
        } else if (url.indexOf(Path.getMineConfirm()) > 0) {
            return true;
        } else if (url.indexOf(Path.getMineResult()) > 0) {
            return true;
        }
        return false;
    }

    static isMineProductInfo() {
        let url = Path.getUrl();
        if (url.indexOf(Path.getMineProductInfo()) > 0) {
            return true;
        }
        return false;
    }

    static getHelpShow() {
        return '/help'
    }

    static isTpTags() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getTpTags()) > 0) {
            return true;
        } else if (url.indexOf(Path.getTpTagsCreate()) > 0) {
            return true;
        } else if (url.indexOf(Path.getTpTagsEdit()) > 0) {
            return true;
        }
        return false;
    }

    static isTpSop() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getTpSop()) > 0) {
            return true;
        } else if (url.indexOf(Path.getTpSopCreate()) > 0) {
            return true;
        } else if (url.indexOf(Path.getTpSopEdit()) > 0) {
            return true;
        }
        return false;
    }


    static isWxCreate() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getWXCreate()) > 0) {
            return true;
        }
        return false;
    }

    static isWXIndCreate() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getWXIndividuationCreate()) > 0) {
            return true;
        } else if (url.indexOf(Path.getWXIndividuationList()) > 0) {
            return true;
        }
        return false;
    }

    static isWXAutoReplay() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getWXAutoReplay()) > 0) {
            return true;
        }
        return false;
    }

    static isLiveCodeCustomerStat() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getLiveCustomCodeDataStat()) > 0) {
            return true;
        }
        return false;
    }

    static isLiveCodeGroupStat() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getLiveGroupCodeDataStat()) > 0) {
            return true;
        }
        return false;
    }

    static isLiveCodeCustomer() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getLiveCodeCustomerList()) > 0) {
            return true;
        } else if (url.indexOf(Path.getLiveCodeCustomerCreate()) > 0) {
            return true;
        } else if (url.indexOf(Path.getLiveCodeCustomerEdit()) > 0) {
            return true;
        } else if (url.indexOf(Path.getLiveCodeCustomerCopy()) > 0) {
            return true;
        } else if (url.indexOf(Path.getLiveCodeCustomerQrcode()) > 0) {
            return true;
        }
        return false;
    }

    static isLiveCodePurchase() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getLiveCodePurchase()) > 0) {
            return true;
        } else if (url.indexOf(Path.getLiveCodePurchaseConfirm()) > 0) {
            return true;
        } else if (url.indexOf(Path.getLiveCodePay()) > 0) {
            return true;
        } else if (url.indexOf(Path.getLiveCodePayConfirm()) > 0) {
            return true;
        } else if (url.indexOf(Path.getLiveCodePayResult()) > 0) {
            return true;
        }
        return false;
    }

    static isLiveCodeGroup() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getLiveCodeGroupList()) > 0) {
            return true;
        } else if (url.indexOf(Path.getLiveCodeGroupCreate()) > 0) {
            return true;
        } else if (url.indexOf(Path.getLiveCodeGroupEdit()) > 0) {
            return true;
        } else if (url.indexOf(Path.getLiveCodeGroupCopy()) > 0) {
            return true;
        } else if (url.indexOf(Path.getLiveCodeGroupQrcode()) > 0) {
            return true;
        }
        return false;
    }

    static isLiveCodeGroupAdd() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getLiveCodeGroupCreate()) > 0) {
            return true;
        } else if (url.indexOf(Path.getLiveCodeGroupEdit()) > 0) {
            return true;
        } else if (url.indexOf(Path.getLiveCodeGroupCopy()) > 0) {
            return true;
        }
        return false;
    }


    static isGroupBuy() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getGroupBuy()) > 0) {
            return true;
        }
        return false;
    }

    static isGroupBuyList() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getGroupBuyList()) > 0) {
            return true;
        } else if (url.indexOf(Path.getGroupBuyCreat()) > 0) {
            return true;
        } else if (url.indexOf(Path.getGroupBuyEdit()) > 0) {
            return true;
        } else if (url.indexOf(Path.getGroupBuyCopy()) > 0) {
            return true;
        } else if (url.indexOf(Path.getGroupBuyRedeemCode()) > 0) {
            return true;
        }
        return false;
    }

    static isPrizeUnlockList() {
        let url = Path.getUrl();
        if (url.indexOf(Path.getPrizeUnlockList()) > 0) {
            return true;
        } else if (url.indexOf(Path.getPrizeUnlockCreate()) > 0) {
            return true;
        } else if (url.indexOf(Path.getPrizeDataAnalysis()) > 0) {
            return true;
        } else if (url.indexOf(Path.getPrizeFans()) > 0) {
            return true;
        } else if (url.indexOf(Path.getPrizeUnlockOrder()) > 0) {
            return true;
        } else if (url.indexOf(Path.getPrizeUnlockCopy()) > 0) {
            return true;
        }
        return false;
    }

    static isPrizeDataAnalysis() {
        let url = Path.getUrl();
        if (url.indexOf(Path.getPrizeDataAnalysis()) > 0) {
            return true;
        }
        return false;
    }

    static isPrizeFans() {
        let url = Path.getUrl();
        if (url.indexOf(Path.getPrizeFans()) > 0) {
            return true;
        }
        return false;
    }

    static isPrizeUnlockOrder() {
        let url = Path.getUrl();
        if (url.indexOf(Path.getPrizeUnlockOrder()) > 0) {
            return true;
        }
        return false;
    }

    static isGroupBuyCash() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getGroupBuyCash()) > 0) {
            return true;
        } else if (url.indexOf(Path.getGroupBuyCashOut()) > 0) {
            return true;
        }
        return false;
    }

    static isGroupBuyOrder() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getGroupBuyOrder()) > 0) {
            return true;
        } else if (url.indexOf(Path.getGroupBuyOrderDetail()) > 0) {
            return true;
        }
        return false;
    }

    static isGroupBuyMsg() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getGroupBuyMsg()) > 0) {
            return true;
        } else if (url.indexOf(Path.getGroupBuyMsgAdd()) > 0) {
            return true;
        } else if (url.indexOf(Path.getGroupBuyMsgEdit()) > 0) {
            return true;
        }
        return false;
    }

    static isPush() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getPushList()) > 0) {
            return true;
        } else if (url.indexOf(Path.getPushCreate()) > 0) {
            return true;
        } else if (url.indexOf(Path.getPushCopy()) > 0) {
            return true;
        } else if (url.indexOf(Path.getPushEdit()) > 0) {
            return true;
        }
        return false;
    }

    static isDis() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getDis()) > 0) {
            return true;
        }

        return false;
    }

    // static isDistribution() {
    //     var url = Path.getUrl();
    //     if (url.indexOf(Path.getDisTribution()) > 0) {
    //         return true;
    //     }
    //
    //     return false;
    // }

    /*新建分销的路径*/
    static isDistribution() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getDisTributionList()) > 0) {
            return true;
        } else if (url.indexOf(Path.getDistriRetailCreate()) > 0) {
            return true;
        } else if (url.indexOf(Path.getDistriRetailEdit()) > 0) {
            return true;
        } else if (url.indexOf(Path.getDistriRetailCopy()) > 0) {
            return true;
        } else if (url.indexOf(Path.getDisTributionChannelList()) > 0) {
            return true;
        } else if (url.indexOf(Path.getDisTributionMsg()) > 0) {
            return true;
        } else if (url.indexOf(Path.getDisTriOrderDetail()) > 0) {
            return true;
        }

        return false;
    }

    static isDisTributionChannel() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getDisTributionChannelList()) > 0) {
            return true;
        } else if (url.indexOf(Path.getchannelCreate()) > 0) {
            return true
        } else if (url.indexOf(Path.getchannelEdit()) > 0) {
            return true
        }

        return false;
    }

    static isDisTributionMsg() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getDisTributionMsg()) > 0) {
            return true;
        } else if (url.indexOf(Path.gotoMsgDistriCreate()) > 0) {
            return true
        } else if (url.indexOf(Path.gotoMsgDistriEdit()) > 0) {
            return true
        }

        return false;
    }


    static isDisRetail() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getDisRetailList()) > 0) {
            return true;
        } else if (url.indexOf(Path.getDisRetailCreate()) > 0) {
            return true;
        } else if (url.indexOf(Path.getDisRetailEdit()) > 0) {
            return true;
        } else if (url.indexOf(Path.getDisRetailCopy()) > 0) {
            return true;
        } else if (url.indexOf(Path.getDisRetailData()) > 0) {
            return true;
        } else if (url.indexOf(Path.getDisRetailRank()) > 0) {
            return true;
        } else if (url.indexOf(Path.getDisRetailCode()) > 0) {
            return true;
        }
        return false;
    }

    static isDisCash() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getDisCashList()) > 0) {
            return true;
        } else if (url.indexOf(Path.getDisCashOut()) > 0) {
            return true;
        }

        return false;
    }

    static isDisPurchase() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getDisPushase()) > 0) {
            return true;
        }

        return false;
    }

    static isWriteOff() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getWriteOffList()) > 0) {
            return true;
        } else if (url.indexOf(Path.getWriteOffCreate()) > 0) {
            return true;
        } else if (url.indexOf(Path.getWriteOffData()) > 0) {
            return true;
        }

        return false;
    }

    static isWriteOffData() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getWriteOffData()) > 0) {
            return true;
        }

        return false;
    }

    static isDisChannel() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getDisChannelList()) > 0) {
            return true;
        } else if (url.indexOf(Path.getDisChannelCreate()) > 0) {
            return true;
        } else if (url.indexOf(Path.getDisChannelEdit()) > 0) {
            return true;
        }

        return false;
    }

    static isDisMsg() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getDisMsg()) > 0) {
            return true;
        } else if (url.indexOf(Path.getDisMsgAdd()) > 0) {
            return true;
        } else if (url.indexOf(Path.getDisMsgEdit()) > 0) {
            return true;
        }

        return false;
    }


    static isDisRetailReport() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getDisRetailReport()) > 0) {
            return true;
        }
        return false;
    }

    static isDisRetailShop() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getDisRetailShop()) > 0) {
            return true;
        } else if (url.indexOf(Path.getDisRetailShopEdit()) > 0) {
            return true;
        }
        return false;
    }


    static isInTemplateMsg(url) {
        if (url) {
            if (url.indexOf('/ext/msg_template/') != -1) {
                return true;
            }
        } else if (window.location.href.indexOf('/ext/msg_template/') != -1) {
            return true;
        }
        return false;
    }

    static isInTaskpost(url) {
        if (url) {
            if (url.indexOf('/ext/taskpost/') != -1) {
                return true;
            }
        } else if (window.location.href.indexOf('/ext/taskpost/') != -1) {
            return true;
        }
        return false;
    }

    static isInTaskpostCreate() {
        var url = Path.getUrl();
        if (url.indexOf(Path.isTpManage()) > 0) {
            return true;
        }
        return false;
    }

    static isInShareTreasure(url) {
        if (url) {
            if (url.indexOf('/ext/st/') != -1) {
                return true;
            }
        } else if (window.location.href.indexOf('/ext/st/') != -1) {
            return true;
        }
        return false;
    }

    static isInChannelQRCode(url) {
        if (url) {
            if (url.indexOf('/ext/channelqrcode/') != -1) {
                return true;
            }
        } else if (window.location.href.indexOf('/ext/channelqrcode/') != -1) {
            return true;
        }
        return false;
    }

    static getUrl() {
        var url = window.location.href;
        if (url.endsWith('/')) {
            url = url.substring(0, url.length - 1);
        }
        return url;
    }

    //是否是公众号涨粉
    static isExt() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getExtPath()) > 0) {
            return true;
        }
        return false;
    }

    static isMyShop() {
        var url = Path.getUrl();
        if (url.indexOf(PATH.myShop) > 0) {
            return true;
        }
        return false;
    }

    static isGoodsList() {
        var url = Path.getUrl();
        if (url.indexOf(PATH.goodsList) > 0) {
            return true;
        } else if (url.indexOf(PATH.goodsCreate) > 0) {
            return true;
        } else if (url.indexOf(PATH.goodsEdit) > 0) {
            return true;
        }

        return false;
    }


    static isTaskPostGoodsList() {
        var url = Path.getUrl();
        if (url.indexOf(PATH.goodsListTaskpost) > 0) {
            return true;
        } else if (url.indexOf(PATH.goodsCreateTaskpost) > 0) {
            return true;
        } else if (url.indexOf(PATH.goodsEditTaskpost) > 0) {
            return true;
        }

        return false;
    }

    static isGoodsOrderList() {
        var url = Path.getUrl();
        if (url.indexOf(PATH.goodsOrderList) > 0) {
            return true;
        } else if (url.indexOf(PATH.goodsOrderDetail) > 0) {
            return true
        }
        return false;
    }

    static isGoodsOrderChecker() {
        let url = Path.getUrl();
        if (url.indexOf(PATH.goodsOrderChecker) > 0) {
            return true;
        } else if (url.indexOf(PATH.goodsOrderCheckerCreate) > 0) {
            return true
        } else if (url.indexOf(PATH.goodsOrderCheckerData) > 0) {
            return true
        }
        return false;
    }

    static isGoodsOrderDeliver() {
        let url = Path.getUrl();
        if (url.indexOf(PATH.goodsOrderDeliver) > 0) {
            return true;
        }
        return false;
    }

    static isTaskPostGoodsOrderList() {
        var url = Path.getUrl();
        if (url.indexOf(PATH.goodsOrderListTaskpost) > 0) {
            return true;
        } else if (url.indexOf(PATH.goodsOrderDetailTaskpost) > 0) {
            return true
        }
        return false;
    }

    static isTaskPostGoodsOrderDeliver() {
        let url = Path.getUrl();
        if (url.indexOf(PATH.goodsOrderDeliverTaskpost) > 0) {
            return true;
        }
        return false;
    }

    static isTaskPostGoodsOrderChecker() {
        let url = Path.getUrl();
        if (url.indexOf(PATH.goodsOrderCheckerTaskpost) > 0) {
            return true;
        }
        return false;
    }

    static isTMCreatePush() {
        var url = Path.getUrl();
        if (url.endsWith(Path.getCreatePushMsgTaskPath())) {
            return true;
        }
        return false;
    }

    static isTMPushRecord() {
        var url = Path.getUrl();
        if (url.endsWith(Path.getMsgTaskRecordPath())) {
            return true;
        } else if (url.indexOf(PATH.tmCreate) > 0) {
            return true
        }
        return false;
    }

    static isTMManage() {
        var url = Path.getUrl();
        if (url.endsWith(Path.getTemplateMsgManagePath())) {
            return true;
        } else if (url.indexOf(Path.getCreateMsgPath()) != -1) {
            return true;
        } else if (url.indexOf(Path.getEditMsgPath()) != -1) {
            return true;
        }
        return false;
    }

    static isTpManage() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getTaskPosterRecordPath()) > 0) {
            return true;
        } else if (url.indexOf(Path.getEditTaskposterPath()) > 0) {
            return true;
        } else if (url.indexOf(Path.getCopyTaskposterPath()) > 0) {
            return true;
        } else if (url.indexOf(Path.getTaskposterDetailPath()) > 0) {
            return true;
        } else if (url.indexOf(Path.getCreateTaskposterPath()) > 0) {
            return true;
        } else if (url.indexOf(Path.getTaskposterFansPath()) != -1) {
            return true;
        }

        return false;
    }

    static isFestivalSignManage() {
        let url = Path.getUrl();
        if (url.indexOf(Path.getFestivalSignList()) > 0) {
            return true;
        } else if (url.indexOf(Path.getFestivalSignCreate()) > 0) {
            return true;
        } else if (url.indexOf(Path.getFestivalSignEdit()) > 0) {
            return true;
        } else if (url.indexOf(Path.getFestivalSignCopy()) > 0) {
            return true;
        }
        return false;
    }

    static isTpCreate() {
        var url = Path.getUrl();
        if (url.endsWith(Path.getCreateTaskposterPath())) {
            return true;
        }
        return false;
    }


    static isCodeManage() {
        var url = Path.getUrl();
        if (url.endsWith(Path.getChannelQRCodeListPath())) {
            return true;
        } else if (url.indexOf(Path.getChannelQRCodeEditPath()) != -1) {
            return true;
        } else if (url.indexOf(Path.getChannelQRCodeStatsPath()) != -1) {
            return true;
        } else if (url.indexOf(Path.getCreateChannelQRCodePath()) != -1) {
            return true;
        }
        return false;
    }

    static isCodeDetail() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getChannelQRCodeStatsPath()) != -1) {
            return true;
        }
        return false;
    }


    static isCodeCreate() {
        var url = Path.getUrl();
        if (url.endsWith(Path.getCreateChannelQRCodePath())) {
            return true;
        }
        return false;
    }

    static isStManage() {
        var url = Path.getUrl();
        if (url.endsWith(Path.getShareTreasureRecordPath())) {
            return true;
        } else if (url.indexOf(Path.getShareTreasureEditPath()) != -1) {
            return true;
        } else if (url.indexOf(Path.getShareTreasureCreatePath()) != -1) {
            return true;
        }
        return false;
    }

    static isStDetail() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getShareTreasureDetailPath()) != -1) {
            return true;
        }
        return false;
    }

    static isStCreate() {
        var url = Path.getUrl();
        if (url.endsWith(Path.getShareTreasureCreatePath())) {
            return true;
        }
        return false;
    }

    static isFansManage() {
        var url = Path.getUrl();
        if (url.endsWith(Path.getFansPath())) {
            return true;
        }
        return false;
    }

    static isFormCreate() {
        var url = Path.getUrl();
        if (url.endsWith(Path.getCreateFormPath())) {
            return true;
        }
        return false;
    }

    static isTaskpostFormManage() {
        var url = Path.getUrl();
        if (url.endsWith(Path.getTaskpostManageFormPath())) {
            return true;
        } else if (url.indexOf(Path.getTaskpostFormDataPath()) != -1) {
            return true;
        } else if (url.indexOf(Path.getTaskpostCreateFormPath()) != -1) {
            return true;
        } else if (url.indexOf(Path.getTaskpostEditFormPath()) != -1) {
            return true;
        } else if (url.indexOf(Path.getTaskpostFormLookPath()) != -1) {
            return true;
        }
        return false;
    }

    static isCorpFormManage() {
        var url = Path.getUrl();
        if (url.endsWith(Path.getCorpManageFormPath())) {
            return true;
        } else if (url.indexOf(Path.getCorpFormDataPath()) != -1) {
            return true;
        } else if (url.indexOf(Path.getCorpCreateFormPath()) != -1) {
            return true;
        } else if (url.indexOf(Path.getCorpEditFormPath()) != -1) {
            return true;
        } else if (url.indexOf(Path.getCorpFormLookPath()) != -1) {
            return true;
        }
        return false;
    }


    static isFormManage() {
        var url = Path.getUrl();
        if (url.endsWith(Path.getManageFormPath())) {
            return true;
        } else if (url.indexOf(Path.getFormDataPath()) != -1) {
            return true;
        } else if (url.indexOf(Path.getCreateFormPath()) != -1) {
            return true;
        } else if (url.indexOf(Path.getEditFormPath()) != -1) {
            return true;
        } else if (url.indexOf(Path.getFormLookPath()) != -1) {
            return true;
        }
        return false;
    }

    static isTpBlacklist() {
        var url = Path.getUrl();
        if (url.endsWith(Path.getBlacklistTaskposterPath())) {
            return true;
        }
        return false;
    }

    static isTpChannel() {
        var url = Path.getUrl();
        if (url.endsWith(Path.getChannelTaskposterPath())) {
            return true;
        } else if (url.indexOf(Path.getTaskposterChannelCreatePath()) != -1) {
            return true;
        } else if (url.indexOf(Path.getTaskposterChannelEditPath()) != -1) {
            return true;
        }
        return false;
    }

    static isTpStas() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getTaskposterStasPath()) != -1) {
            return true;
        }
        return false;
    }

    static isTpFans() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getTaskposterFansPath()) != -1) {
            return true;
        }
        return false;
    }

    static isTaskpostRedeemcodeManage() {
        var url = Path.getUrl();
        if (url.endsWith(Path.getTaskpostManageRedeemcodePath())) {
            return true;
        } else if (url.indexOf(Path.getTaskpostRedeemcodeDataPath()) != -1) {
            return true;
        } else if (url.indexOf(Path.getTaskpostRedeemcodeCreatePath()) != -1) {
            return true;
        }
        return false;
    }

    static isCorpRedeemcodeManage() {
        var url = Path.getUrl();
        if (url.endsWith(Path.getCorpManageRedeemcodePath())) {
            return true;
        } else if (url.indexOf(Path.getCorpRedeemcodeDataPath()) != -1) {
            return true;
        } else if (url.indexOf(Path.getCorpRedeemcodeCreatePath()) != -1) {
            return true;
        }
        return false;
    }


    static isRedeemcodeManage() {
        var url = Path.getUrl();
        if (url.endsWith(Path.getManageRedeemcodePath())) {
            return true;
        } else if (url.indexOf(Path.getRedeemcodeDataPath()) != -1) {
            return true;
        } else if (url.indexOf(Path.getRedeemcodeCreatePath()) != -1) {
            return true;
        }
        return false;
    }

    static isRedeemcodeCreate() {
        var url = Path.getUrl();
        if (url.endsWith(Path.getCreateRedeemcodePath())) {
            return true;
        }
        return false;
    }

    // 是否是我的
    static isMine() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getMine()) > 0) {
            return true;
        }
        return false;
    }

    static isOrderList() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getOrderList()) > 0) {
            return true;
        } else if (url.indexOf(Path.getOrderDetail()) > 0) {
            return true;
        } else if (url.indexOf(Path.getMineOrderList()) > 0) {
            return true;
        } else if (url.indexOf(Path.getMineOrderDetail()) > 0) {
            return true;
        }
        return false;
    }

    static isOrderAdd() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getOrderAdd()) > 0) {
            return true;
        } else if (url.indexOf(Path.getOrderConfirm()) > 0) {
            return true;
        } else if (url.indexOf(Path.getOrderPay()) > 0) {
            return true;
        } else if (url.indexOf(Path.getOrderRenew()) > 0) {
            return true;
        }
        return false;
    }

    // 建群
    static isGroupTaskList() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getGroupTaskList()) > 0) {
            return true;
        } else if (url.indexOf(Path.getGroupTaskCreate()) > 0) {
            return true;
        } else if (url.indexOf(Path.getGroupTaskEdit()) > 0) {
            return true;
        } else if (url.indexOf(Path.getGroupTaskCopy()) > 0) {
            return true;
        } else if (url.indexOf(Path.getTaskGroupList()) > 0) {
            return true;
        } else if (url.indexOf(Path.getGroupMembers()) > 0) {
            return true;
        }
        return false;
    }

    static isGroupPurchase() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getGroupPurchase()) > 0) {
            return true;
        } else if (url.indexOf(Path.getGroupPurchasePay()) > 0) {
            return true;
        } else if (url.indexOf(Path.getGroupPurchaseStream()) > 0) {
            return true;
        } else if (url.indexOf(Path.getGroupPurchaseAccount()) > 0) {
            return true;
        } else if (url.indexOf(Path.getGroupPurchasePayResult()) > 0) {
            return true;
        } else if (url.indexOf(Path.getGroupPurchaseRecord()) > 0) {
            return true;
        } else if (url.indexOf(Path.getGroupPurchaseRecordDe()) > 0) {
            return true;
        }
        return false;
    }

    static isGroupTaskBlackList() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getGroupBlackList()) > 0) {
            return true;
        }
        return false;
    }

    static isGroupDataCount() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getGroupDataCount()) > 0) {
            return true;
        }
        return false;
    }

    static isGroupRobotList() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getGroupRobotList()) > 0) {
            return true;
        }
        return false;
    }

    static isGroupSendList() {
        var url = Path.getUrl();
        if (url.indexOf(Path.getGroupSendList()) > 0) {
            return true;
        } else if (url.indexOf(Path.getGroupCreateSend()) > 0) {
            return true
        }
        return false;
    }

    static getFestivalSignList() {
        return PATH.festivalSignList;
    }

    static getFestivalSignCreate() {
        return PATH.festivalSignCreate;
    }

    static getFestivalSignEdit() {
        return PATH.festivalSignEdit;
    }

    static getFestivalSignCopy() {
        return PATH.festivalSignCopy;
    }

    static getPrizeUnlockCreate() {
        return '/index/prizeunlock/create'
    }

    static getPrizeUnlockEdit() {
        return '/index/prizeunlock/edit'
    }

    static getPrizeUnlockCopy() {
        return '/index/prizeunlock/copy'
    }

    static getDistriRetailCreate() {
        return "/index/distri/retail/create"
    }

    static getDistriRetailEdit() {
        return "/index/distri/retail/edit/"
    }

    static getDistriRetailCopy() {
        return "/index/distri/retail/copy/"
    }

    // 分销的渠道管理
    static getchannelList() {
        return '/index/distri/channel/list'
    }

    static getchannelCreate() {
        return '/index/distri/channel/create'
    }

    static getchannelEdit() {
        return '/index/distri/channel/edit/'
    }

    //分销的消息模板
    static gotoMsgDistriList() {
        return "/index/distri/msg/list"
    }

    static gotoMsgDistriCreate() {
        return "/index/distri/msg/create"
    }

    static gotoMsgDistriEdit() {
        return "/index/distri/msg/edit/"
    }


    //拼团
    static getMarketGroupbuyActivityManageCommon() {
        return path_groupbuy_activity_manage
    }

    //资产管理
    static getAccountSettle() {
        return path_assert_settle
    }


    /***************new************/

    static isInPath(path, url) {
        if (url.indexOf(path) > 0) {
            return true;
        }
        return false;
    }

    static getDashboard() {
        return path_dashboard;
    }

    static getIndex() {
        return path_index
    }

    static getZkCloudHome() {
        return path_zkcloud_home;
    }

    static getZkCloudSeat() {
        return path_zkcloud_seat;
    }

    static isDashboard() {
        let url = Path.getUrl();
        let path = Path.getDashboard();
        return Path.isInPath(path, url);
    }

    static isIndex() {
        let url = Path.getUrl();
        let path = Path.getIndex();
        return Path.isInPath(path, url);
    }

    static isZkCloudHome() {
        let url = Path.getUrl();
        let path = Path.getZkCloudHome();
        return Path.isInPath(path, url);
    }

    static getMarket() {
        return path_market;
    }

    //营销中心-分销
    static getMarketDistri() {
        return path_market_distri;
    }

    static isMarketDistri() {
        let url = Path.getUrl();
        let path = Path.getMarketDistri();
        return Path.isInPath(path, url);
    }

    static getMarketDistriMange() {
        return path_market_distri_manage;
    }

    static getMarketDistriActivityCreate() {
        return path_market_distri_activity_create;
    }

    static getMarketDistriActivityCopy() {
        return path_market_distri_activity_copy;
    }

    static getMarketDistriActivityEdit() {
        return path_market_distri_activity_edit;
    }

    static getMarketDistriChannelCreate() {
        return path_market_distri_channel_create;
    }

    static getMarketDistriChannelEdit() {
        return path_market_distri_channel_edit
    }

    static getMarketDistriChannelMange() {
        return path_market_distri_channel_manage;
    }

    static getMarketDistriReportMange() {
        return path_market_distri_report_manage;
    }

    static getMarketDistriRankMange() {
        return path_market_distri_rank_manage;
    }

    static getMarketDistriOrderMange() {
        return path_market_distri_order_manage;
    }

    static getMarketDistriOrderDetail() {
        return path_market_distri_order_detail;
    }

    static getDistriNotify() {
        return path_distri_notify;
    }

    static getDistriNotifyCreate() {
        return path_distri_notify_create;
    }

    static getDistriNotifyEdit() {
        return path_distri_notify_edit;
    }

    static isDistriNotify() {
        let url = Path.getUrl();
        let path = Path.getDistriNotify();
        return Path.isInPath(path, url);
    }

    //营销中心-一元解锁
    static getMarketPrizeUnlock() {
        return path_market_prizeunlock;
    }

    static isMarketPrizeUnlock() {
        let url = Path.getUrl();
        let path = Path.getMarketPrizeUnlock();
        return Path.isInPath(path, url);
    }

    static getMarketPrizeUnlockManage() {
        return path_market_prizeunlock_manage;
    }

    static getMarketPrizeUnlockActivityCreate() {
        return path_market_prizeunlock_activity_create;
    }

    static getMarketPrizeUnlockActivityCopy() {
        return path_market_prizeunlock_activity_copy;
    }

    static getMarketPrizeUnlockActivityEdit() {
        return path_market_prizeunlock_activity_edit;
    }

    static getMarketPrizeUnlockOrderDetail() {
        return path_market_prizeunlock_order_detail
    }

    static getMarketGroupbuy() {
        return path_market_groupbuy;
    }

    static getMarketRedeemCode() {
        return path_market_redeemcode;
    }

    static isMarketRedeemCode() {
        let url = Path.getUrl();
        let path = Path.getMarketRedeemCode();
        return Path.isInPath(path, url);
    }

    static getMarketVerifier() {
        return path_market_verifier;
    }

    static isMarketVerifier() {
        let url = Path.getUrl();
        let path = Path.getMarketVerifier();
        return Path.isInPath(path, url);
    }
    //批量发货
    static getBatchDeliver(){
        return path_market_batch_deliver
    }
    static isGetBatchDeliver(){
        let url = Path.getUrl();
        let path = Path.getBatchDeliver();
        return Path.isInPath(path, url);
    }

    static getMarketForm() {
        return path_market_form;
    }

    static getRedeemcode() {
        return path_market_redeemcode
    }

    static isMarketForm() {
        let url = Path.getUrl();
        let path = Path.getMarketForm();
        return Path.isInPath(path, url);
    }

    static getMarketFormCreate() {
        return path_market_form_create;
    }


    static getMarketFormEdit() {
        return path_market_form_edit;
    }

    static getMarketFormCopy() {
        return path_market_form_copy;
    }

    static getMarketFormData() {
        return path_market_form_data;
    }

    static getMarketVerifierCreate() {
        return path_market_verifier_create;
    }

    static getMarketVerifierData() {
        return path_market_verifier_data;
    }

    static getMarketRedeemCodeData() {
        return path_market_redeemcode_data;
    }

    static getMarketRedeemCodeCreate() {
        return path_market_redeemcode_create;
    }

    static isMarketGroupbuy() {
        let url = Path.getUrl();
        let path = Path.getMarketGroupbuy();
        return Path.isInPath(path, url);
    }

    static getMarketGroupBuyManage() {
        return path_market_groupbuy_manage
    }

    static getGroupBuyActivityCreate() {
        return path_groupbuy_activity_create
    }

    static getGroupBuyActivityEdit() {
        return path_groupbuy_activity_edit
    }

    static getGroupBuyActivityCopy() {
        return path_groupbuy_activity_copy
    }

    static getGroupBuyLadderActivityEdit() {
        return path_groupbuy_ladder_activity_edit
    }

    static getGroupBuyLadderActivityCopy() {
        return path_groupbuy_ladder_activity_copy
    }

    static getGroupBuyLadderActivityCreate() {
        return path_groupbuy_ladder_activity_create
    }

    static getGroupBuyActivityManagePage() {
        return path_groupbuy_activity_manage
    }

    static getGroupBuyLadderActivityManagePage() {
        return path_groupbuy_ladder_activity_manage_page
    }

    static getGroupBuyLadderMange() {
        return path_groupbuy_ladder_activity_manage
    }

    static isGroupBuyLadderMange() {
        let url = Path.getUrl();
        let path = Path.getGroupBuyLadderMange();
        return Path.isInPath(path, url);
    }

    static getGroupBuyNotify() {
        return path_groupbuy_notify;
    }

    static getGroupBuyNotifyCreate() {
        return path_groupbuy_notify_create;
    }

    static getGroupBuyNotifyEdit() {
        return path_groupbuy_notify_edit;
    }

    static isGroupBuyNotify() {
        let url = Path.getUrl();
        let path = Path.getGroupBuyNotify();
        return Path.isInPath(path, url);
    }

    static goGroupBuyOrderDetail() {
        return path_groupbuy_activity_order_detail;
    }

    static goGroupBuyLadderOrderDetail() {
        return path_groupbuy_ladder_activity_order_copy;
    }

    static getMarketConfig() {
        return path_market_config;
    }

    static getMpConfig() {
        return path_mp_config;
    }

    static getMarketConfigBrand() {
        return path_market_config_brand;
    }

    static getMarketConfigCs() {
        return path_market_config_cs;
    }

    static isMarketConfig() {
        let url = Path.getUrl();
        let path = Path.getMarketConfig();
        return Path.isInPath(path, url);
    }

    static isMpConfig() {
        let url = Path.getUrl();
        let path = Path.getMpConfig();
        return Path.isInPath(path, url);
    }

    static getWxPayConfig() {
        return path_wxpay_config;
    }

    static getMemberConfig() {
        return path_member_config;
    }

    static isMemberConfig() {
        let url = Path.getUrl();
        let path = Path.getMemberConfig();
        return Path.isInPath(path, url);
    }

    static isWxPayConfig() {
        let url = Path.getUrl();
        let path = Path.getWxPayConfig();
        return Path.isInPath(path, url);
    }

    static getCorpManageConfig() {
        return path_corp_manage_config;
    }

    static isCorpManageConfig() {
        let url = Path.getUrl();
        let path = Path.getCorpManageConfig();
        return Path.isInPath(path, url);
    }

    static goConfigBrand() {
        return path_market_config_brand;
    }

    static isConfigBrand() {
        let url = Path.getUrl();
        let path = Path.goConfigBrand();
        return Path.isInPath(path, url);
    }

    static goConfigAccount() {
        return path_market_config_Account;
    }

    static isConfigAccount() {
        let url = Path.getUrl();
        let path = Path.goConfigAccount();
        return Path.isInPath(path, url);
    }

    static goConfigRedeemCode() {
        return path_market_config_RedeemCode;
    }

    static isConfigRedeemCode() {
        let url = Path.getUrl();
        let path = Path.goConfigRedeemCode();
        return Path.isInPath(path, url);
    }

    static goConfigOChecker() {
        return path_market_config_RedeemCode;
    }

    static isConfigRedeemCode() {
        let url = Path.getUrl();
        let path = Path.goConfigRedeemCode();
        return Path.isInPath(path, url);
    }

    static goConfigOAChecker() {
        return path_market_config_ochecker;
    }

    static isConfigOAChecker() {
        let url = Path.getUrl();
        let path = Path.goConfigOAChecker();
        return Path.isInPath(path, url);
    }

    static goConfigOABind() {
        return path_market_config_oa_bind;
    }

    static isConfigOABind() {
        let url = Path.getUrl();
        let path = Path.goConfigOAChecker();
        return Path.isInPath(path, url);
    }

    static goMarketAssets() {
        return path_market_assets_overview;
    }

    static isMarketAssets() {
        let url = Path.getUrl();
        let path = Path.goMarketAssets();
        return Path.isInPath(path, url);
    }

    static goMarketAssetsStatements() {
        return path_market_assets_statements;
    }

    static isMarketAssetsStatements() {
        let url = Path.getUrl();
        let path = Path.goMarketAssetsStatements();
        return Path.isInPath(path, url);
    }

    static goMarketAssetsWithdraws() {
        return path_market_assets_withdraws;
    }

    static goMarketAssetsRecharge() {
        return path_market_assets_recharge;
    }


    static isMarketAssetsWithdraws() {
        let url = Path.getUrl();
        let path = Path.goMarketAssetsWithdraws();
        return Path.isInPath(path, url);
    }

    static goMarketAssetsSummary() {
        return path_market_assets_summary;
    }

    static isMarketAssetsSummary() {
        let url = Path.getUrl();
        let path = Path.goMarketAssetsSummary();
        return Path.isInPath(path, url);
    }

    static getMyAssert() {
        return path_assert_overview;
    }

    static isMyAssert() {
        let url = Path.getUrl();
        let path = Path.getMyAssert();
        return Path.isInPath(path, url);
    }

    static gotoAssetSettle() {
        return path_assert_settle
    }

    static isMarketAssetsSettle() {
        let url = Path.getUrl();
        let path = Path.gotoAssetSettle();
        return Path.isInPath(path, url);
    }

//   配置
    static gotoConfigWxPay() {
        return path_market_config_payAdd
    }

    static isConfigWxPay() {
        let url = Path.getUrl();
        let path = Path.gotoConfigWxPay();
        return Path.isInPath(path, url);
    }

    static getConfigPayEdit() {
        return path_market_config_pay_edit
    }

    static getConfigPay() {
        return path_market_config_pay_create
    }

    static getConfigRefund() {
        return "/index/config/refund"
    }

    static getPrizeMsg() {
        return path_prizeunlock_msg
    }

    static isPrizeMsg() {
        let url = Path.getUrl();
        let path = Path.getPrizeMsg();
        return Path.isInPath(path, url);
    }

    /**
     * 获取登录路由
     * @returns {string}
     */
    static getUserLogin(target) {
        let source = Util.getUrlArg("source");
        if (target) {
            if (source) {
                return path_login + '?target=' + target + '&source=' + source;
            } else {
                return path_login + '?target=' + target
            }
        } else {
            if (source) {
                return path_login + '?source=' + source
            }
        }
        return path_login;
    }

    /**
     * 获取用户协议路径
     * @returns {string}
     */
    static getUserAgreement() {
        return path_useragreement
    }

    static getUserLoginHttpUrl() {
        let url = DOMAIN.replace('/zksc', '') + path_login;
        if (window.location.href.indexOf("/cloud") > 0) {
            url += '?target=zkcloud'
        }
        return url;
    }

    static getHomeHttpUrl() {
        let url = DOMAIN.replace('zksc', 'home.html');
        return url;
    }

    /**
     * 获取注册路由
     * @returns {string}
     */
    static getUserRegister(target) {
        let source = Util.getUrlArg("source");
        if (target) {
            if (source) {
                return path_register + '?target=' + target + '&source=' + source;
            } else {
                return path_register + '?target=' + target
            }
        } else {
            if (source) {
                return path_register + '?source=' + source
            }
        }
        return path_register;
    }

    /**
     * 获取重置密码路由
     * @returns {string}
     */
    static getUserFindPass(target) {
        if (target) {
            return path_findpass + '?target=' + target;
        }
        return path_findpass;
    }

    /**
     * 客户管理
     * @returns {string}
     */
    static geCustomerMange() {
        return path_customer_manage;
    }

    static isCustomerMange() {
        let url = Path.getUrl();
        let path = Path.geCustomerMange();
        return Path.isInPath(path, url);
    }

    /**
     * 客户黑名单
     * @returns {string}
     */
    static getCustomerBlackList() {
        return path_customer_blacklist;
    }

    static isCustomerBlackList() {
        let url = Path.getUrl();
        let path = Path.getCustomerBlackList();
        return Path.isInPath(path, url);
    }

    /**
     * 客户标签
     * @returns {string}
     */
    static getCustomerTag() {
        return path_customer_tag;
    }

    static isCustomerTag() {
        let url = Path.getUrl();
        let path = Path.getCustomerTag();
        return Path.isInPath(path, url);
    }

    //裂变获客-任务宝
    static getFissionCustomer() {
        return path_fission_customer
    }

    static getFissionCustomerManage() {
        return path_fission_customer_manage;
    }

    static isFissionCustomer() {
        let url = Path.getUrl();
        let path = Path.getFissionCustomer();
        return Path.isInPath(path, url);
    }

    //裂变获客-群裂变
    static getFissionChat() {
        return path_fission_chat
    }

    static getFissionCustomerChat() {
        return path_fission_chat_manage;
    }

    static isFissionChat() {
        let url = Path.getUrl();
        let path = Path.getFissionChat();
        return Path.isInPath(path, url);
    }

    //企微任务宝活动创建
    static getFissionCustomerActivityCreateCommon() {
        return path_fission_customer_activity_create_common;
    }
    static getFissionCustomerActivityCreateCommonWithpro() {
        return path_fission_customer_activity_create_withpro;
    }

    //渠道 数据统计
    static getFissionCustomerChannelStatistics() {
        return path_fission_customer_report_manage;
    }

    //跳转渠道管理页面
    static getFissionCustomerChanne() {
        return path_fission_customer_channel_manage
    }

    //渠道 新建
    static getFissionCustomerChannelCreate() {
        return path_fission_customer_channel_create;
    }

    //渠道 编辑
    static getFissionCustomerChannelEdit() {
        return path_fission_customer_channel_edit;
    }

    //活动管理 参与用户
    static getFissionCustomerActivityList() {
        return path_fission_customer_users_manage
    }

    //活动管理 编辑活动
    static getFissionCustomerActivityEdit() {
        return path_fission_customer_activity_edit;
    }

    //活动管理 复制活动
    static getFissionCustomerActivityCopy() {
        return path_fission_customer_activity_copy;
    }

    //活动管理
    static getFissionCustomerActivityDelete() {
        return path_fission_customer_activity_delete;
    }

    static getFissionCustomerActivityMass() {
        return path_fission_customer_activity_mass;
    }

    //修改配置
    static getConfigCorpManage() {
        return path_config_corp_manage;
    }

    //社群裂变 渠道创建
    static getFissionChatChannelCreate() {
        return path_fission_chat_channel_create
    }

    //社群裂变 渠道编辑
    static getFissionChatChannelEdit() {
        return path_fission_chat_channel_edit
    }

    //社群裂变 渠道管理
    static getFissionChatChannelManage() {
        return path_fission_chat_channel_manage
    }

    //社群裂变 数据统计
    static getFissionChatActivityReport() {
        return path_fission_chat_activity_report
    }

    static getFissionChatRoomManage() {
        return path_fission_chat_room_manage
    }


    static getFissionChatActivityCreateCommon() {
        return path_fission_chat_activity_create_common
    }
    static getFissionChatActivityCreateWithpro() {
        return path_fission_chat_activity_create_withpro
    }

    static getFissionChatActivityEdit() {
        return path_fission_chat_activity_edit
    }

    static getFissionChatActivityCopy() {
        return path_fission_chat_activity_copy
    }

    // 我的订单页面
    static getMineOrderMyOrder() {
        return path_mine_order_myOrder
    }

    // 产品续费页面
    static getMineOrderProductRenewal() {
        return path_mine_order_productRenewal
    }

    //确认订单页面
    static getMineOrderConfirmAnOrder() {
        return path_mine_order_confirmAnOrder
    }

    //红包裂变
    static getFissionRedpacket() {
        return path_fission_redpacket
    }

    static getFissionRedpacketManage() {
        return path_fission_redpacket_manage
    }

    static isFissionRedpacket() {
        let url = Path.getUrl();
        let path = Path.getFissionRedpacket();
        return Path.isInPath(path, url);
    }

    static getFissionRedpacketActivityCreateCommon() {
        return path_fission_redpacket_activity_create_common
    }

    static getFissionRedpacketActivityCreateWithpro() {
        return path_fission_redpacket_activity_create_withpro
    }

    static getFissionRedpacketActivityEdit() {
        return path_fission_redpacket_activity_edit
    }

    static getFissionRedpacketActivityCopy() {
        return path_fission_redpacket_activity_copy
    }

    static getFissionRedpacketActivityRepoet() {
        return path_fission_redpacket_activity_report
    }

    static getFissionRedpacketActivityGroupSend() {
        return path_fission_redpacket_activity_group_send
    }

    static getFissionRedpacketChannelCreate() {
        return path_fission_redpacket_channel_create
    }

    static getFissionRedpacketChannelEdit() {
        return path_fission_redpacket_channel_edit
    }

    //抽奖裂变
    static getFissionLottery() {
        return path_fission_lottery
    }

    static isFissionLottery() {
        let url = Path.getUrl();
        let path = Path.getFissionLottery();
        return Path.isInPath(path, url);
    }

    static getFissionLotteryManage() {
        return path_fission_lottery_manage
    }

    //抽奖裂变的新建活动路由
    static getFissionLotteryActivityCreateCommon() {
        return path_fission_lottery_activity_create_common
    }
    static getFissionLotteryActivityCreateWithpro() {
        return path_fission_lottery_activity_create_withpro
    }

    //抽奖裂变
    static getFissionLotteryChannelCreate() {
        return path_fission_lottery_channel_create
    }

    //抽奖裂变的编辑
    static getFissionLotteryActivityEdit() {
        return path_fission_lottery_activity_edit
    }

    //抽奖裂变的复制活动
    static getFissionLotteryActivityCopy() {
        return path_fission_lottery_activity_copy
    }

    //抽奖裂变跳转渠道管理页面
    static getFissionLotteryChannelManage() {
        return path_fission_lottery_channel_manage
    }

    //抽奖裂变的跳转数据统计页面
    static getFissionLotteryActivityReport() {
        return path_fission_lottery_activity_report
    }

    //抽奖裂变的 渠道编辑
    static getFissionLotteryChannelEdit() {
        return path_fission_lottery_channel_edit
    }

    //渠道活码
    static getChannelCodeWords() {
        return path_drainage_channel
    }

    static isFissionChannel() {
        let url = Path.getUrl();
        let path = Path.getChannelCodeWords();
        return Path.isInPath(path, url);
    }

    static getFissionChannel() {
        return path_drainage_channel_manage
    }

    //新建渠道活码
    static getDrainageChannelQrActivityCreate() {
        return path_drainage_channel_activity_create
    }

    //复制渠道活码
    static getDrainageChannelQrActivityCopy() {
        return path_drainage_channel_activity_copy
    }

    //编辑渠道活码
    static getDrainageChannelQrActivityEdit() {
        return path_drainage_channel_activity_edit
    }

    //渠道活码数据统计
    static getDrainageChannelQrActivityReport() {
        return path_drainage_channel_activity_report
    }

    //新建取消按钮
    static getDrainageChannel() {
        return path_drainage_channel
    }

    //红包裂变 渠道管理
    static getRedpacketChannleManage() {
        return path_fission_redpacket_channel_manage
    }


    //引流链接
    static getDrainageLinks() {
        return path_drainage_links
    }

    static isDrainageLinks() {
        let url = Path.getUrl();
        let path = Path.getDrainageLinks();
        return Path.isInPath(path, url);
    }

    static getLinksManage() {
        return path_drainage_links_manage
    }

    //引流链接管理
    static getLinksLinkManage() {
        return path_drainage_links_linkManage
    }

    //数据分析
    static getLinksLinkReport() {
        return path_drainage_links_linkReport
    }

    //引流新建
    static getLinksLinkCreate() {
        return path_drainage_links_activity_create
    }

    //引流编辑
    static getLinksLinkEdit() {
        return path_drainage_links_activity_edit
    }

    //引流加群创建
    static getLinksGroupCreate() {
        return path_drainage_links_activity_group_create
    }

    //引流加群创建
    static getLinksGroupEdit() {
        return path_drainage_links_activity_group_edit
    }

    //社群红包裂变
    static getFissionGroupRed() {
        return path_fission_group_red
    }

    static isFissionGroupRed() {
        let url = Path.getUrl();
        let path = Path.getFissionGroupRed();
        return Path.isInPath(path, url);
    }

    static getGroupRedManage() {
        return path_fission_group_red_manage
    }

    static getGroupRedActivityCreateCommon() {
        return path_fission_group_red_activity_create_common
    }

    static getGroupRedActivityCreateWithpro() {
        return path_fission_group_red_activity_create_withpro
    }

    static getGroupRedActivityEdit() {
        return path_fission_group_red_activity_edit
    }

    static getGroupRedActivityCopy() {
        return path_fission_group_red_activity_copy
    }

    static getGroupRedChannelCreate() {
        return path_fission_group_red_channel_create
    }

    static getGroupRedChannelEdit() {
        return path_fission_group_red_channel_edit
    }

    static getGroupRedChannelManage() {
        return path_fission_group_red_channel_manage
    }

    static getGroupRedActivityReport() {
        return path_fission_group_red_activity_report
    }

    static getGroupRedRoomManage() {
        return path_fission_group_red_room_mamage
    }


    //跳转子账号
    static getBypassAccountList() {
        return path_mine_bypassAccount_list
    }

    static getMineSubscribeMsg() {
        return path_mine_subscribe_msg
    }
}

const path_useragreement = '/userAgreement';
const path_login = '/login';
const path_register = '/register';
const path_findpass = '/findPass';
const path_dashboard = '/dashboard';
const path_index = '/index';
const path_zkcloud_home = '/cloud';
const path_zkcloud_seat = path_zkcloud_home + '/seat';
const path_market = '/index/market';
const path_corp = '/index/corp';
const path_market_distri = '/index/market/distri';
const path_market_distri_manage = path_market_distri + '/manage/';
const path_market_distri_activity_create = path_market_distri + '/activity/create';
const path_market_distri_activity_copy = path_market_distri + '/activity/copy/';
const path_market_distri_activity_edit = path_market_distri + '/activity/edit/';
const path_market_distri_channel_create = path_market_distri + '/channel/create/';
const path_market_distri_channel_edit = path_market_distri + "/channel/edit/";
const path_market_distri_channel_manage = path_market_distri_manage + 'channel';
const path_market_distri_order_manage = path_market_distri_manage + 'order';
const path_market_distri_report_manage = path_market_distri_manage + 'report';
const path_market_distri_rank_manage = path_market_distri_manage + 'rank';
const path_market_distri_order_detail = path_market_distri + '/order/detail/';
const path_distri_notify = '/index/market/distri/notify';
const path_distri_notify_create = '/index/market/distri/notify/create';
const path_distri_notify_edit = '/index/market/distri/notify/edit/';
const path_market_prizeunlock = '/index/market/prizeunlock';
const path_market_prizeunlock_manage = path_market_prizeunlock + '/manage/';
const path_market_prizeunlock_activity_create = path_market_prizeunlock + '/activity/create';
const path_market_prizeunlock_activity_copy = path_market_prizeunlock + '/activity/copy/';
const path_market_prizeunlock_activity_edit = path_market_prizeunlock + '/activity/edit/';
const path_market_prizeunlock_order_detail = path_market_prizeunlock + '/order/detail/';
const path_prizeunlock_msg = '/index/market/prizeunlock/msg';
const path_market_groupbuy = '/index/market/groupbuy';
const path_market_redeemcode = '/index/market/redeemcode';
const path_market_verifier = '/index/market/verifier';
const path_market_batch_deliver = '/index/market/batchdeliver';//批量发货
const path_market_form = '/index/market/form';
const path_market_form_create = path_market_form + '/create';
const path_market_form_edit = path_market_form + '/edit/';
const path_market_form_copy = path_market_form + '/copy/';
const path_market_form_data = path_market_form + '/data/';
const path_market_verifier_create = path_market_verifier + '/create';
const path_market_verifier_data = path_market_verifier + '/data/';
const path_market_redeemcode_data = path_market_redeemcode + '/data/';
const path_market_redeemcode_create = path_market_redeemcode + '/create';
const path_market_groupbuy_manage = path_market_groupbuy + '/manage/';
const path_groupbuy_activity_create = '/index/market/groupbuy/activity/create';
const path_groupbuy_activity_edit = "/index/market/groupbuy/activity/edit/";
const path_groupbuy_activity_copy = "/index/market/groupbuy/activity/copy/";
const path_groupbuy_activity_order_detail = "/index/market/groupbuy/order/detail/";
const path_groupbuy_activity_manage = '/index/market/groupbuy/manage/common/';
const path_groupbuy_ladder_activity_manage = '/index/market/groupbuy/manage/ladder?tabName=activity';
const path_groupbuy_ladder_activity_create = '/index/market/groupbuy/ladder/activity/create';
const path_groupbuy_ladder_activity_edit = "/index/market/groupbuy/ladder/activity/edit/";
const path_groupbuy_ladder_activity_copy = "/index/market/groupbuy/ladder/activity/copy/";
const path_groupbuy_ladder_activity_order_copy = "/index/market/groupbuy/ladder/manage/order/detail/";
const path_groupbuy_ladder_activity_manage_page = '/index/market/groupbuy/ladder/manage/page/';
const path_groupbuy_notify = '/index/market/groupbuy/notify';
const path_groupbuy_notify_create = '/index/market/groupbuy/notify/create';
const path_groupbuy_notify_edit = '/index/market/groupbuy/notify/edit/';
const path_market_config = '/index/config/market/';
const path_market_config_brand = path_market_config + 'brand';
const path_market_config_cs = path_market_config + 'cs';
const path_mp_config = '/index/config/mp';
const path_wxpay_config = '/index/config/wxpay';
const path_member_config = '/index/config/member'
const path_corp_manage_config = '/index/config/corp/manage';
const path_market_config_Account = '/index/market/config/oa';
const path_market_config_RedeemCode = '/index/market/config/redeemcode';
const path_market_config_ochecker = '/index/market/config/ochecker';
// const path_market_config_ochecker = '/index/market/config/ochecker';
const path_market_config_oa_bind = '/index/market/config/oa/unbind';
const path_market_config_payAdd = "/index/market/config/payAdd";
const path_market_config_pay_create = "/index/market/config/pay/create/";
const path_market_config_pay_edit = "/index/market/config/pay/edit/";
const path_market_assets_overview = '/index/assets/overview';
const path_market_assets_statements = '/index/assets/statements';
const path_market_assets_withdraws = '/index/assets/withdraws';
const path_market_assets_recharge = '/index/assets/recharge';
const path_market_assets_summary = '/index/assets/summary';
const path_assert_overview = '/index/assets/overview';
const path_assert_settle = "/index/assets/settle/";

//客户管理
const path_customer_manage = "/index/customer/manage";
const path_customer_blacklist = "/index/customer/blacklist";
const path_customer_tag = "/index/customer/tag";
//客户裂变
const path_fission_customer = '/index/fission/customer';
const path_fission_customer_manage = path_fission_customer + '/manage/';
const path_fission_customer_activity_create_common = path_fission_customer + '/activity/create/common';
const path_fission_customer_activity_create_withpro = path_fission_customer + '/activity/create/withpro';
const path_fission_customer_report_manage = path_fission_customer_manage + 'report/';
const path_fission_customer_channel_manage = path_fission_customer_manage + 'channel/'
const path_fission_customer_channel_create = path_fission_customer + '/channel/create';
const path_fission_customer_channel_edit = path_fission_customer + '/channel/edit/';
const path_fission_customer_users_manage = path_fission_customer_manage + 'users/';
const path_fission_customer_activity_edit = path_fission_customer + '/activity/edit/';
const path_fission_customer_activity_copy = path_fission_customer + '/activity/copy/';
const path_fission_customer_activity_delete = path_fission_customer + '/activity/delete/';
const path_fission_customer_activity_mass = path_fission_customer + '/activity/mass/';
//社群裂变
const path_fission_chat = '/index/fission/chat';
const path_fission_chat_manage = path_fission_chat + '/manage/';
const path_fission_chat_activity_create_common = path_fission_chat + '/activity/create/common';
const path_fission_chat_activity_create_withpro = path_fission_chat + '/activity/create/withpro';
const path_fission_chat_activity_edit = path_fission_chat + '/activity/edit/';
const path_fission_chat_activity_copy = path_fission_chat + '/activity/copy/';
const path_fission_chat_channel_manage = path_fission_chat_manage + 'channel/';
const path_fission_chat_activity_report = path_fission_chat_manage + 'report/';
const path_fission_chat_room_manage = path_fission_chat_manage + 'room';
const path_fission_chat_channel_create = path_fission_chat + '/channel/create';
const path_fission_chat_channel_edit = path_fission_chat + '/channel/edit/';
//红包裂变
const path_fission_redpacket = '/index/fission/redpacket';
const path_fission_redpacket_manage = path_fission_redpacket + '/manage/';
const path_fission_redpacket_activity_create_common = path_fission_redpacket + '/activity/create/common';
const path_fission_redpacket_activity_create_withpro = path_fission_redpacket + '/activity/create/withpro';
const path_fission_redpacket_activity_edit = path_fission_redpacket + '/activity/edit/';
const path_fission_redpacket_activity_copy = path_fission_redpacket + '/activity/copy/';
const path_fission_redpacket_activity_report = path_fission_redpacket_manage + 'report/';
const path_fission_redpacket_activity_group_send = path_fission_redpacket + '/activity/send/';
const path_fission_redpacket_channel_manage = path_fission_redpacket_manage + 'channel/';
const path_fission_redpacket_channel_create = path_fission_redpacket + '/channel/create';
const path_fission_redpacket_channel_edit = path_fission_redpacket + '/channel/edit/';


//抽奖裂变
const path_fission_lottery = '/index/fission/lottery';
const path_fission_lottery_manage = path_fission_lottery + '/manage/';
const path_fission_lottery_activity_create_common = path_fission_lottery + '/activity/create/common' //新建抽奖裂变的活动
const path_fission_lottery_activity_create_withpro = path_fission_lottery + '/activity/create/withpro' //新建抽奖裂变的活动
const path_fission_lottery_channel_create = path_fission_lottery + '/channel/create' //抽奖裂变渠道创建
const path_fission_lottery_channel_edit = path_fission_lottery + '/channel/edit/'//抽奖裂变的渠道编辑
const path_fission_lottery_activity_edit = path_fission_lottery + '/activity/edit/'//抽奖裂变的编辑
const path_fission_lottery_activity_copy = path_fission_lottery + '/activity/copy/'//抽奖裂变的复制活动
const path_fission_lottery_channel_manage = path_fission_lottery_manage + 'channel/'//抽奖裂变的跳转渠道管理页面
const path_fission_lottery_activity_report = path_fission_lottery_manage + 'report/'//抽奖裂变的跳转数据统计页面

//社群红包裂变
const path_fission_group_red = '/index/fission/groupRed';
const path_fission_group_red_manage = path_fission_group_red + '/manage/';
const path_fission_group_red_activity_create_common = path_fission_group_red + '/activity/create/common' //新建活动
const path_fission_group_red_activity_create_withpro = path_fission_group_red + '/activity/create/withpro' //新建活动
const path_fission_group_red_activity_edit = path_fission_group_red + '/activity/edit/'//编辑
const path_fission_group_red_activity_copy = path_fission_group_red + '/activity/copy/'//复制活动
const path_fission_group_red_channel_create = path_fission_group_red + '/channel/create' //渠道创建
const path_fission_group_red_channel_edit = path_fission_group_red + '/channel/edit/'//渠道编辑
const path_fission_group_red_channel_manage = path_fission_group_red_manage + 'channel/'//渠道管理
const path_fission_group_red_activity_report = path_fission_group_red_manage + 'report/'//数据统计
const path_fission_group_red_room_mamage = path_fission_group_red_manage + 'room'//群聊管理

//渠道活码
const path_drainage_channel = '/index/drainage/channelqr';
const path_drainage_channel_manage = path_drainage_channel + '/manage/';
const path_drainage_channel_activity_create = path_drainage_channel + '/activity/create'//新建渠道活码
const path_drainage_channel_activity_edit = path_drainage_channel + '/activity/edit/'//编辑渠道活码
const path_drainage_channel_activity_copy = path_drainage_channel + '/activity/copy/' //复制渠道活码
const path_drainage_channel_activity_report = path_drainage_channel + '/manage/report/'

//引流链接
const path_drainage_links = '/index/drainage/links'
const path_drainage_links_manage = path_drainage_links + '/manage/'
const path_drainage_links_linkManage = path_drainage_links_manage + 'activity'
const path_drainage_links_linkReport = path_drainage_links_manage + 'report/'
const path_drainage_links_activity_create = path_drainage_links + '/activity/create'
const path_drainage_links_activity_edit = path_drainage_links + '/activity/edit/'
//引流加群
const path_drainage_links_activity_group_create = path_drainage_links + '/activity/group/create'
const path_drainage_links_activity_group_edit = path_drainage_links + '/activity/group/edit/'

//修改配置
const path_config_corp = '/index/config/corp';
const path_config_corp_manage = path_config_corp + '/manage/';

export {Path}

//跳转我的订单页面
const path_mine_order = '/order';
const path_mine_order_myOrder = path_mine_order + '/myOrder';//跳转我的订单页面
const path_mine_order_productRenewal = path_mine_order + '/productRenewal/';//跳转产品续费页面
const path_mine_order_confirmAnOrder = path_mine_order + '/confirmAnOrder';//跳转确认订单页面

//订阅消息路由
const path_mine_subscribe = '/subscribe';
const path_mine_subscribe_msg = path_mine_subscribe + '/subscribe-msg';


//跳转子账号页面
const path_mine_bypassAccount = '/subAccount';
const path_mine_bypassAccount_list = path_mine_bypassAccount + '/list'; //跳转子账号管理页面

// 根据路由直接跳转页面
export let RedirectKey = 'path_url';
export let RedirectPath = {
    'distri': Path.getDisRetailList(),
    'groupbuy': Path.getGroupBuyList(),
    'livecode': Path.getLiveCodeGroupList(),
    'livecode_kf': Path.getLiveCodeCustomerList(),
    'taskposter': Path.getTaskPosterRecordPath(),
    'msg': Path.getMsgTaskRecordPath()
};